<template>
  <div>
    <base-header type="gradient-yellow" class="pb-6 pb-8 pt-5 pt-md-8">
      <base-dropdown v-if="activeModules.length > 0">
        <base-button slot="title" type="warning" class="dropdown-toggle">
          OMS Reports - {{ _.startCase(currentProfile) }}
        </base-button>
        <a
          v-for="profile in activeModules"
          :key="profile.id"
          @click.prevent="
            setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)
          "
          class="dropdown-item"
          href="#"
          >{{ profile.name }}</a
        >
      </base-dropdown>
      <base-dropdown v-else>
        <base-button slot="title" type="primary" class="dropdown-toggle">
          Oms Reports
        </base-button>
        <a class="dropdown-item" disabled>No active module/s under this feature</a>
      </base-dropdown>
    </base-header>
    <!-- <img
      style="display: none"
      id="reportLogo"
      :src="imagepath"
      alt="Report Logo"
      @error="$event.target.src = '/img/logo2.065d54ac.png'"
      crossorigin="anonymous"
    /> -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- <oms-collection-report v-if="currentProfile == 'oms_collection_reports'"></oms-collection-report> -->
          <daily-sales-report
            v-if="currentProfile == 'daily_sales_reports'"
          ></daily-sales-report>
          <ecomm-inventory-report
            v-if="currentProfile == 'ecomm_inventory_reports'"
          ></ecomm-inventory-report>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage";
import DailySalesReport from "../Oms Reports/DailySalesReport";
import EcommInventoryReport from "../Oms Reports/EcommInvetoryReport.vue";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      activeModules: [],
      accessRights: [],
      imagepath: secureStorage.getItem("account_logo"),
    };
  },
  mounted: async function () {
    var component_x = this;

    var categoryId = await HTTPRequest.getRequest(
      component_x.endPoint + "/system_module_categories?code=R-008&status=A",
      null,
      null
    );
    if (categoryId[0] != undefined) {
      component_x.activeModules = await HTTPRequest.getRequest(
        component_x.endPoint +
          "/system_module_categories/" +
          categoryId[0].id +
          "/enabled_modules",
        null,
        null
      );
      if (component_x.activeModules.length > 0) {
        var profile = _.snakeCase(component_x.activeModules[0].name);
        component_x.setCurrentProfile(
          _.pluralize(profile),
          component_x.activeModules[0].id
        );
      } else {
        component_x.setCurrentProfile(null, null);
      }
    }
  },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
  },
  components: {
    DailySalesReport,
    EcommInventoryReport,
  },
  methods: {
    ...mapActions(["updateCurrentProfile", "updateParameters"]),
    async setCurrentProfile(profile, id) {
      var accessRightsRequest = await HTTPRequest.getRequest(
        this.endPoint +
          "users/" +
          secureStorage.getItem("userId") +
          "/access_rights?system_module_id=" +
          id,
        null
      );
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id];
      } else {
        this.accessRights = [];
      }
      this.updateCurrentProfile(profile);
    },
  },
};
</script>

<style></style>
